var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-refresh",on:{"click":_vm.refresh}},[_c('img',{staticClass:"btn-icon",attrs:{"src":require("@/assets/icons/logOut.svg")}}),_c('div',{staticClass:"btn-title"},[_vm._v("Log Out")])])}
var staticRenderFns = []

export { render, staticRenderFns }